import React from 'react';
import { Link } from 'react-router-dom';
import { DocumentTextIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import DisclaimerFooter from '../DisclaimerFooter';

const MethodologyPage = () => {
  return (
    <div className="min-h-screen bg-bg-100">
      <div className="px-6 py-8">
        {/* Breadcrumbs */}
        <nav className="mb-6">
          <div className="flex items-center text-sm text-text-300">
            <Link to="/learn" className="hover:text-primary-100 transition-colors">
              Learn
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2" />
            <span className="text-text-100">Methodology</span>
          </div>
        </nav>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-text-100 mb-4 flex items-center gap-3">
            <DocumentTextIcon className="h-8 w-8 text-primary-100" />
            Investment Methodology
          </h1>
          <p className="text-lg text-text-200">
            Our comprehensive investment approach combining alternative data and enhanced quantitative factors.
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-bg-200 rounded-lg p-6 border border-bg-300">
          <h2 className="text-xl font-semibold text-text-100 mb-4">Our Investment Philosophy</h2>
          <p className="text-text-200 leading-relaxed mb-6">
            Our investment methodology combines alternative data and enhanced quantitative factors to deliver differentiated portfolios. 
            We go beyond traditional financial metrics by integrating unique signals such as analyst estimate quality, earnings call sentiment, and innovation capacity.
          </p>
          <p className="text-text-200 leading-relaxed mb-6">
            Our quantitative models are designed to dynamically adjust for sector and accounting differences, focusing on forward-looking value, quality, momentum, and volatility. 
            This disciplined approach aims to identify mispriced opportunities and manage risk effectively, providing a robust foundation for long-term outperformance.
          </p>

          <h3 className="text-lg font-semibold text-text-100 mb-3">Key Principles</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-bg-100 p-4 rounded-lg">
              <h4 className="font-medium text-text-100 mb-2">Data-Driven Approach</h4>
              <p className="text-sm text-text-200">
                We leverage multiple data sources beyond traditional financial statements, including alternative datasets that provide unique insights into company prospects.
              </p>
            </div>
            <div className="bg-bg-100 p-4 rounded-lg">
              <h4 className="font-medium text-text-100 mb-2">Systematic Process</h4>
              <p className="text-sm text-text-200">
                Our models follow a rigorous, repeatable process that removes emotional bias and ensures consistent application of our investment philosophy.
              </p>
            </div>
            <div className="bg-bg-100 p-4 rounded-lg">
              <h4 className="font-medium text-text-100 mb-2">Risk Management</h4>
              <p className="text-sm text-text-200">
                We incorporate multiple risk controls and constraints to manage portfolio risk while seeking to maximize risk-adjusted returns.
              </p>
            </div>
            <div className="bg-bg-100 p-4 rounded-lg">
              <h4 className="font-medium text-text-100 mb-2">Continuous Innovation</h4>
              <p className="text-sm text-text-200">
                We continuously research new data sources and modeling techniques to enhance our investment process and maintain our competitive edge.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-bg-200">
        <DisclaimerFooter small />
      </div>
    </div>
  );
};

export default MethodologyPage; 